import { EixoForm } from '@presentation/components/organisms'
import { AddModal } from '@presentation/components/templates'
import { AddModalProps } from '@presentation/types/components/templates'

import { validationSchema } from './shared'

type Props = {
  onAdd: () => void
}

const AddEixoModal: React.FC<Props> = ({ onAdd }) => {
  const modalConfigs: AddModalProps = {
    path: '/eixos',
    formId: 'add-eixo',
    nameForTitle: 'Eixo',
    validationSchema,
    onAdd
  }

  return (
    <AddModal {...modalConfigs}>
      <EixoForm />
    </AddModal>
  )
}

export default AddEixoModal
